module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1005-3d692c6b20379d665f214d3b2c5331b5.png";